import { render, staticRenderFns } from "./TwoColumnVouch.vue?vue&type=template&id=38de8401"
import script from "./TwoColumnVouch.vue?vue&type=script&lang=js"
export * from "./TwoColumnVouch.vue?vue&type=script&lang=js"
import style0 from "./TwoColumnVouch.vue?vue&type=style&index=0&id=38de8401&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports